import { FC } from 'react'
import s from './FilterButtons.module.sass'
import { Button } from '@shared/ui/Actions/Button'
import { useAppSelector } from '@app/model/store/client'
import { LoadingSpinner } from '@shared/ui/Feedback/LoadingSpinner'
import { Text } from '@shared/ui/Typography/Text'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

interface Props {
  className?: string
  handleRemove: () => void
  handleSave: () => void
  position?: 'fixed' | 'sticky'
}

const FilterButtons: FC<Props> = ({ className, handleRemove, handleSave, position = 'fixed' }) => {
  const { loading, restaurants, pagination } = useAppSelector((store) => store.features.restaurant_filters)

  // до первого превью pagination пустой — текущая страница уже валидна.
  // пустой ответ restaurant_list значит комбинация невозможна, кнопку закрываем
  const inEnabled = pagination == null || Boolean(restaurants?.length)

  const handleSaveInner = () => {
    !loading && inEnabled && handleSave()
  }

  return (
    <BlockBoundary>
      <div className={`${s.buttons} ${className || ''}`} data-position={position}>
        <Button className={s.remove} sizes={'L'} mode={'white-border'} onClick={handleRemove}>
          <Text sizes={'M'}>Сбросить</Text>
        </Button>
        <Button className={s.save} sizes={'L'} mode={'black'} onClick={handleSaveInner} data-loading={!!loading}>
          <Text sizes={'M'} className={s['save-text']}>
            {inEnabled ? 'Показать' : 'Не найдено'}
          </Text>
          <LoadingSpinner loading={loading} size={20} className={s['save-loading']} />
        </Button>
      </div>
    </BlockBoundary>
  )
}

export default FilterButtons
